import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaAcuerdos from "./Equipos/CreaModals/CreaAcuerdos";
import Cookies from "universal-cookie";

function Titulo12SeccionA(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // 🔹 OBTENER ACUERDOS
  const obtenerAcuerdos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAcuerdosSindicalesPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => {
        setList(response.data || []);
      })
      .catch((error) => {
        console.error("Error al obtener acuerdos:", error);
      });
  };

  useEffect(() => {
    if (props.idSolicitud) {
      obtenerAcuerdos();
    }
  }, [props.idSolicitud]);

  // 🔹 CALLBACK CUANDO SE CREA (SIN RELOAD)
  const onAcuerdoCreado = () => {
    obtenerAcuerdos();
  };

  // 🔹 ELIMINAR SIN RELOAD
  const eliminarAcuerdo = (id) => {
    if (!window.confirm("¿Está seguro de eliminar este acuerdo?")) return;

    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarAcuerdosSindicalesPorId?Id=${id}`,
      data: {
        tipoAccion: "Eliminación de registro Acuerdos sindicales",
        idUsuario: cookies.get("id"),
      },
    })
      .then(() => {
        setList((prev) => prev.filter((item) => item.id !== id));
        alert("Acuerdo eliminado correctamente.");
      })
      .catch((error) => {
        console.error("Error al eliminar:", error);
        alert("Error al eliminar el acuerdo.");
      });
  };

  const nombreRuta = window.location.href.includes("ProcesoAutoevaluacion");

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Registre la siguiente información
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 && nombreRuta && (
            <CreaAcuerdos
              idSolicitud={props.idSolicitud}
              onAcuerdoCreado={onAcuerdoCreado}
            />
          )}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre del Sindicato</th>
                  <th>Fecha del Acuerdo</th>
                  <th>Acuerdos establecidos</th>
                  <th>SolicitudId</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.fechaAcuerdo}</td>
                      <td>{item.acuerdoEstablecido}</td>
                      <td>{item.solicitudId}</td>
                      <td>
                        {nombreRuta && (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarAcuerdo(item.id)}
                          >
                            Eliminar
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo12SeccionA;
